export default {"src":"/_next/static/media/client-auth-background-mobile.8d291389.svg","height":720,"width":375};